import * as ko from 'knockout'
import template from './race.starter.tpl.html'
import { Params, RaceStarterViewModel } from './RaceStarterViewModel'

if (!ko.components.isRegistered('race-starter')) {
  ko.components.register('race-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new RaceStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
